export enum WorkflowParticipantRoles {
    ANY = 'any',
    ASSIGNEE = 'assignee',
    OWNER = 'owner'
}
